import { defineMessages } from "react-intl";

const messages = defineMessages({
  heading: {
    id: "carPromo.heading",
    description: "Heading for car promo",
    defaultMessage: "Rental cars in {location}",
  },
  smallCar: {
    id: "carPromo.smallCar",
    description: "Label for small rental car",
    defaultMessage: "Small",
  },
  mediumCar: {
    id: "carPromo.mediumCar",
    description: "Label for medium rental car",
    defaultMessage: "Medium",
  },
  largeCar: {
    id: "carPromo.largeCar",
    description: "Label for large rental car",
    defaultMessage: "Large",
  },
});

export default messages;
